module.exports = __webpack_public_path__ + "img/scene-charging.60f7f9f1.jpg";